import { $Qll, $Q } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';
import api from '../services/api';
import { mediaQuery } from '../utils/media-query';

/**
 * Change the collection filter
 */
function changeCollectionFilter(form) {
  const submitLoader = $Q('.js-collection-loader');

  if (submitLoader) submitLoader.style.display = 'flex';

  form.submit();
}

/**
 * Get section data
 * @param {string} currentUrl - Root of url
 * @param {string} urlParams - Query url
 * @returns {string} - Response object
 * @author Daniel Santos
 */
async function fetchSection(currentUrl, urlParams) {
  const filtersURL = await api.shopifySectionByUrl(
    `${window.location.origin}${currentUrl}`,
    `${currentUrl === '/search' ? 'main-search' : 'collection-products'}`,
    `?${urlParams}&section_id`
  );

  return filtersURL;
}

const filterCollectionMobile = () => {
  mediaQuery('(max-width: 767px)', () => {
    const filterInput = $Qll('#filter input[type="checkbox"]');
    const sortBy = $Qll('#filter input[type="radio"]');

    if (sortBy) filterInput.push(...sortBy);

    if (!filterInput) return;

    filterInput.forEach((input) => {
      input.addEventListener('change', async (e) => {
        const formData = new FormData(e.target.closest('form'));
        const searchParams = new URLSearchParams(formData).toString();

        const config = $Q('#data-config');

        if (!config) return;

        const { currentUrl } = config.dataset;

        const data = await fetchSection(currentUrl, searchParams.toString());
        const productsCount = $Q('#js-products-count', stringToHTML(data));
        const btn = $Q('.filter-form__submit span');

        if (!btn) return;

        btn.textContent = productsCount.dataset.productsCount;
      });
    });
  });
};

const virtualClick = (form) => {
  const btn = $Q('.filter-form__submit.desktop');

  if (!btn) return;

  btn.addEventListener('click', () => {
    changeCollectionFilter(form);
  });
};

/**
 * Filter by collection
 * @returns {Void}
 */
export const filterCollection = () => {
  filterCollectionMobile();

  const form = $Q('#filter form.filter-form');

  if (!form) return;

  form.addEventListener('submit', () => {
    changeCollectionFilter(form);
  });

  mediaQuery('(min-width: 768px)', () => {
    virtualClick(form);
  });
};
